import { render, staticRenderFns } from "./app-install-btn.vue?vue&type=template&id=d6c779ae&scoped=true&"
import script from "./app-install-btn.vue?vue&type=script&lang=js&"
export * from "./app-install-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c779ae",
  null
  
)

export default component.exports